<template>
  <div ref="bg" class="bg flex-row" :class="_class">
    <div class="panel" :class="right ? 'right-gap' : 'left-gap'">
      <div class="content flex-column" :class="_class">
        <div class="markdown" v-if="message" v-html="$marked(message)"/>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {get_message, initialize_cache} from "@/code/messages";
import Merge from "@/mixins/Merge.js";

export default {
  name: 'TextSection',
  mixins: [
    Merge,
  ],
  components: {
  },
  props: {
    right: Boolean,
    mode: {type: String, default: "dark"},
    message_id: {type: String, default: "welcome"},
    image_name: {type: String, default: "w1366.jpg"},
  },
  data() {
    return {
      message: undefined,
    }
  },

  watch: {
    image_name() {
      this.update();
    }
  },

  mounted() {
    this.update();
  },

  created() {
    initialize_cache().then(() => {
      get_message(this.message_id).then((r) => {
        this.message = r;
      });
    });
  },
  computed: {
    _class() {
      return this.merge(
        this.$layout.isMobile ? `mobile ${this.mode}` : undefined,
        this.right ? 'right' : 'left',
        );
    },
  },
  methods: {
    update() {
      if (this.$refs.bg)
        this.$refs.bg.style.backgroundImage = `url("/img/${this.image_name}")`;
    }
  }
}
</script>

<style lang="scss" scoped>

.light.mobile.bg {
  .panel {
    //margin-left: 110px;
    max-width: 60%;
  }
}

.dark.mobile.bg {
  .panel {
    background: transparent;
    //border-radius: 0;
    max-width: 100%;
    color: #FCFCFC;
  }
}

.mobile.bg {
  border-radius: 0;
  padding-top: 30px;
  padding-bottom: 30px;
}

.bg.right {
  background-position: top left;
  justify-content: flex-end;
  .panel {
    border-radius: 0px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}

.bg {
  padding-top: 70px;
  padding-bottom: 70px;
  width: 100%;
  //height: 600px;
  //border-radius: 5px;
  //background-image: url("/img/w1366.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top right;

  justify-content: flex-start;

  .panel {
    border-radius: 0px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    //max-width: 70%;
    //flex: 0 1;
    color: $color-1-active;
    background: white;

    .content.left {
      padding-right: 20px;
    }
    .content.right {
      padding-left: 20px;
      //text-align: justify;
      //word-break: break-all;
    }

    .content {
      padding-top: 35px;
      padding-bottom: 35px;
      gap: 50px;

      .markdown {
        max-width: 500px;
      }
    }
  }
}
</style>
